import { useContext, useEffect } from 'react'
import { SessionContext } from 'spa/App'

// ログインしていない時にトップにリダイレクトする
// ログイン状態を返す
// ex: 初期状態で中身を表示させたくない場合の使い方
// const loggedIn = useLoggedIn()
//
// if (!loggedIn) {
//   return null
// }
const useLoggedIn = () => {
  const session = useContext(SessionContext)
  const loggedIn = session?.user

  useEffect(() => {
      if (session && !loggedIn) {
      location.href = '/'
      }
  }, [session])

  return loggedIn
}

export { useLoggedIn }
